import Axios from '../context/axios/AxiosControl'

export const getBillExternals = () => async (dispatch) => {
    dispatch({
        type: 'BILLEXTERNAL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/billExternal/getall/', {
            headers: { auth: localStorage.getItem('jwt') },
        })
        if (status === 200) {
            dispatch({
                type: 'BILLEXTERNAL_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_NOT_LOADING'
        })
    }
}

export const getBillExternal = (billExternal) => async (dispatch) => {
    dispatch({
        type: 'BILLEXTERNAL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/billExternal/get/'+ billExternal, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'BILLEXTERNAL_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_NOT_LOADING'
        })
    }
}

export const addBillExternal = (billExternaldata, typeBillExternal) => async (dispatch) => {
    try {
        const { data, status} = await Axios.post('/api/billExternal/register', billExternaldata, {
                headers: { auth: localStorage.getItem('jwt') },
                params: {typeBillExternal}
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'BILLEXTERNAL_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_NOT_LOADING'
        })
    }
}

export const editBillExternal = (billExternaldata, idBillExternal, typeBillExternal) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/billExternal/edit/' + idBillExternal, billExternaldata, {
                headers: { auth: localStorage.getItem('jwt')},
                params: {typeBillExternal}
            }
        )
        console.log(data)
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'BILLEXTERNAL_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_ERROR'
        })
    }
}

export const removeBillExternal = (billExternal) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/billExternal/remove/' + billExternal, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263) {
            dispatch({
                type: 'BILLEXTERNAL_REMOVE_RESULT',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_NOT_LOADING'
        })
    }
}

export const addDocument = (billExternaldata,idBillExternal) => async (dispatch) => {
    try {
        let documentUrl = ''

        if(billExternaldata.documentUrl !== null && billExternaldata.documentUrl !== undefined && billExternaldata.documentUrl !== '' && typeof billExternaldata.documentUrl !== 'string'){
            let fileData = new FormData()
            fileData.append('file', billExternaldata.documentUrl)
            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: localStorage.getItem('jwt')
                }
            })
            documentUrl = data
        }else{
            documentUrl = billExternaldata.documentUrl
        }
        if(documentUrl){
            const { data, status} = await Axios.put('/api/billExternal/registerdocument/' + idBillExternal,
                    {
                        documentDescription: billExternaldata.documentDescription,
                        documentUrl: documentUrl
                    },
                    {   headers: { auth: localStorage.getItem('jwt') }
                }
            )
            if (status === 200 || status === 264) {
                dispatch({
                    type: 'BILLEXTERNAL_DOCUMENT_ADD_SUCCESS',
                    payload: data
                })
            }
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_NOT_LOADING'
        })
    }
}

export const deleteDocument = (document, idBillExternal) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/billExternal/removedocument/'+ idBillExternal,
             {document},{ headers: { auth: localStorage.getItem('jwt') }}
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'BILLEXTERNAL_DOCUMENT_DELETE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BILLEXTERNAL_NOT_LOADING'
        })
    }
}